import { useState } from "react";

function useModal(
    { show = false, title = "", data = {} } = {
        show: false,
        title: "",
        data: {},
    }
) {
    const [modal, setModal] = useState({
        show,
        title,
        data,
    });

    function open(props = {}) {
        setModal((prev) => ({
            show: true,
            data: Object.prototype.hasOwnProperty.call(props, "data")
                ? props.data
                : prev.data,
            title: Object.prototype.hasOwnProperty.call(props, "title")
                ? props.title
                : prev.title,
        }));
    }

    function close(props = {}) {
        setModal((prev) => ({
            show: false,
            data: Object.prototype.hasOwnProperty.call(props, "data")
                ? props.data
                : prev.data,
            title: Object.prototype.hasOwnProperty.call(props, "title")
                ? props.title
                : prev.title,
        }));
    }

    function set({
        show = "undefined",
        title = "undefined",
        data = "undefined",
    }) {
        setModal((prev) => {
            return {
                show: show !== "undefined" ? show : prev.show,
                data: data !== "undefined" ? data : prev.data,
                title: title !== "undefined" ? title : prev.title,
            };
        });
    }

    return {
        set,
        open,
        close,
        show: modal.show,
        data: modal.data,
        title: modal.title,
    };
}

export default useModal;
